import React from 'react'

import { connect } from 'react-redux'
import { setWebsitename, setWebsiteurl, setWebsiteBio, setWebsite, selectTemplate } from '../../actions/website-action'
import { setUser, setSignin, setRoute, setToken } from '../../actions/user-action'
import { setImages,  setActivitiesOpen, setActivitiesEdit, setCustomization, setSelectToolbar } from '../../actions/create-action'

import { store } from '../../store'

import { Redirect } from 'react-router-dom'

import First from './Template/First'
import Second from './Template/Second'
import Third from './Template/Third'
import Fourth from './Template/Fourth'
import Fifth from './Template/Fifth'
import Template from './Template'
import AddData from './AddData'
import Register from '../Register/Register'
import RegURL from '../Register/URL'

const mapStateToProps = (state) => {
  let user = state.user.user
  let isSignedIn = state.user.isSignedIn
  let route = state.user.route
  let website = state.website.website
  let images = state.images
  let open = state.activities.open
  let edit = state.activities.edit
  let color = state.activities.color
  let customization = state.customization
  return {
    user: user,
    isSignedIn: isSignedIn,
    route: route,
    website: website,
    images: images,
    open: open,
    edit: edit,
    color: color,
    customization: customization,
    themeAbout: false
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUser: (user) => dispatch(setUser(user)),
    onImagesAction: (image) => dispatch(setImages(image)),
    onSignin: (signin) => dispatch(setSignin(signin)),
    onWebsite: (site) => dispatch(setWebsite(site)),
    onWebsitename: (name) => dispatch(setWebsitename(name)),
    onWebsiteurl: (url) => dispatch(setWebsiteurl(url)),
    onWebsiteBio: (bio) => dispatch(setWebsiteBio(bio)),
    onSelectTemplate: (theme) => dispatch(selectTemplate(theme)),
    onRouteChange: (route) => dispatch(setRoute(route)),
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
    onEdit: (edit) => dispatch(setActivitiesEdit(edit)),
    onCustomization: (custom) => dispatch(setCustomization(custom)),
    onSelectToolbar: (select) => dispatch(setSelectToolbar(select)),
    onToken: (token) => dispatch(setToken(token))
  }
}

const initialstate = {
    highlight: null,
    menu: false,
    clickInside: false,
    outerdiv: false,
    controller: '',
    tokenValid: false,
    profile_name: store.getState().customization.custom[0],
    profile_bio: store.getState().customization.custom[1],
    about: store.getState().customization.custom[2],
    icons: store.getState().customization.custom[3],
    background: store.getState().customization.custom[4],
    fonts: [],
    font_name: ''
  };

class Home extends React.Component {
  constructor(props) {
    super();
    this.state = initialstate
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  };
componentDidMount() {
  let { custom } = store.getState().customization
  custom.map((value,i) => {
        switch(value.class) {
        case 'background':
          if(this.state.background !== custom[i])
          this.setState({
            background: custom[i]
          })
          break;
        case 'profile_name':
          if(this.state.profile_name !== custom[i])
          this.setState({
            profile_name: custom[i]
          })
          break;
        case 'profile_bio':
          if(this.state.profile_bio !== custom[i])
          this.setState({
            profile_bio: custom[i]
          })
          break;
        case 'icons':
          if(this.state.icons !== custom[i])
          this.setState({
            icons: custom[i]
          })
          break;
        case 'about':
          if(this.state.about !== custom[i])
          this.setState({
          about: custom[i]
        })
          break;
      }
  })
  document.addEventListener('mousedown', this.handleClickOutside)
}
componentWillMount() {
  if(!this.state.tokenValid && store.getState().user.user !== null) {
      fetch(`${process.env.REACT_APP_API}/valid`, {
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
          username: store.getState().user.user.username,
          token: store.getState().user.token
          })
        })
        .then((response)=> {
          response.json()
          .then((data)=>{
            if(data.auth === "false") {
              this.props.onSignin(false)
              this.setState({tokenValid: true})
              localStorage.clear()
              window.location = '/signin'
            }
          })
        })
    }
}
componentWillUnmount() {
  document.removeEventListener('mousedown', this.handleClickOutside);
}
onHighlight = (item) => {
  this.setState({highlight: item})
}
onImageHover = (text) => {
  this.setState({imageHover: text})
}
setWrapperRef(node) {
  this.wrapperRef = node;
}
handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
    {
      if(store.getState().activities.open !== '')
      this.props.onOpen('')
    }
  }
onClickInside = () => {
  this.setState({clickInside: true})
}
onClickOutside = () => {
  this.setState({clickInside: false})
}
onOuterDiv = () => {
  this.setState({outerdiv: true})
}
onInnerDiv = () => {
  this.setState({outerdiv: false})
}
onController = (change) => {
  this.setState({controller: change})
}
onAboutSwitch = () => {
  this.setState({themeAbout: !this.state.themeAbout})
}
   render() {
     console.log(this.state.fonts)
     const { onToken, onImagesAction, onWebsite, onWebsitename, onWebsiteBio, onWebsiteurl, onSelectTemplate, onUser, onSignin, onEdit, onOpen, onRouteChange, onCustomization, onSelectToolbar} = this.props
     if(this.state.tokenValid && !store.getState().user.isSignedIn) {
        return <Redirect to={'/signin'}/>
     }
   	switch(store.getState().user.route) {
   	case 'dashboard':
      return (
         <Redirect to={'/dashboard'}/>
      );
    case 'register':
      return (
         <Register
         onRouteChange={onRouteChange}
         onSignin={onSignin}
         onUser={onUser}
         onWebsite={onWebsite}
         onToken={onToken}
         onImagesAction={onImagesAction}/>
      );
    case 'url':
      return (
         <RegURL
         onRouteChange={onRouteChange}
         websiteurl={onWebsiteurl}/>
      );
    case 'first':
    this.componentDidMount()
      return (
         <First
        onUser={onUser}
        onSignin={onSignin}
        onEdit={onEdit}
        onOpen={onOpen}
        onCustomization={onCustomization}
        onSelectToolbar={onSelectToolbar}
        onRouteChange={onRouteChange}
        onHighlight={this.onHighlight}
        onWebsitename={onWebsitename}
        onWebsiteBio={onWebsiteBio}
        highlight={this.state.highlight}
        handleOffClick={this.handleOffClick}
        setWrapperRef={this.setWrapperRef}
        onClickInside={this.onClickInside}
        onClickOutside={this.onClickOutside}
        controller={this.state.controller}
        onController={this.onController}
        profile_name = {this.state.profile_name}
        profile_bio = {this.state.profile_bio}
        about = {this.state.about}
        icons = {this.state.icons}
        background = {this.state.background}
        font_name = {this.state.font_name}
         />
      );
    case 'second':
    this.componentDidMount()
      return (
         <Second
        onUser={onUser}
        onSignin={onSignin}
        onEdit={onEdit}
        onOpen={onOpen}
        onCustomization={onCustomization}
        onSelectToolbar={onSelectToolbar}
        onRouteChange={onRouteChange}
        onHighlight={this.onHighlight}
        onWebsitename={onWebsitename}
        onWebsiteBio={onWebsiteBio}
        highlight={this.state.highlight}
        handleOffClick={this.handleOffClick}
        setWrapperRef={this.setWrapperRef}
        onClickInside={this.onClickInside}
        onClickOutside={this.onClickOutside}
        controller={this.state.controller}
        onController={this.onController}
        profile_name = {this.state.profile_name}
        profile_bio = {this.state.profile_bio}
        about = {this.state.about}
        icons = {this.state.icons}
        background = {this.state.background}
        onOuterDiv = {this.onOuterDiv}
        onInnerDiv = {this.onInnerDiv}
        outerdiv = {this.state.outerdiv}
        font_name = {this.state.font_name}
         />
      );
    case 'third':
    this.componentDidMount()
      return (
         <Third
        onUser={onUser}
        onSignin={onSignin}
        onEdit={onEdit}
        onOpen={onOpen}
        onCustomization={onCustomization}
        onSelectToolbar={onSelectToolbar}
        onRouteChange={onRouteChange}
        onHighlight={this.onHighlight}
        onWebsitename={onWebsitename}
        onWebsiteBio={onWebsiteBio}
        highlight={this.state.highlight}
        handleOffClick={this.handleOffClick}
        setWrapperRef={this.setWrapperRef}
        onClickInside={this.onClickInside}
        onClickOutside={this.onClickOutside}
        controller={this.state.controller}
        onController={this.onController}
        profile_name = {this.state.profile_name}
        profile_bio = {this.state.profile_bio}
        about = {this.state.about}
        icons = {this.state.icons}
        background = {this.state.background}
        onOuterDiv = {this.onOuterDiv}
        onInnerDiv = {this.onInnerDiv}
        outerdiv = {this.state.outerdiv}
        font_name = {this.state.font_name}
         />
      );
    case 'fourth':
    this.componentDidMount()
      return (
         <Fourth
        onUser={onUser}
        onSignin={onSignin}
        onEdit={onEdit}
        onOpen={onOpen}
        onCustomization={onCustomization}
        onSelectToolbar={onSelectToolbar}
        onRouteChange={onRouteChange}
        onHighlight={this.onHighlight}
        onWebsitename={onWebsitename}
        onWebsiteBio={onWebsiteBio}
        highlight={this.state.highlight}
        handleOffClick={this.handleOffClick}
        setWrapperRef={this.setWrapperRef}
        onClickInside={this.onClickInside}
        onClickOutside={this.onClickOutside}
        controller={this.state.controller}
        onController={this.onController}
        profile_name = {this.state.profile_name}
        profile_bio = {this.state.profile_bio}
        about = {this.state.about}
        icons = {this.state.icons}
        background = {this.state.background}
        onOuterDiv = {this.onOuterDiv}
        onInnerDiv = {this.onInnerDiv}
        outerdiv = {this.state.outerdiv}
        font_name = {this.state.font_name}
         />
      );
    case 'fifth':
    this.componentDidMount()
      return (
         <Fifth
        onUser={onUser}
        onSignin={onSignin}
        onEdit={onEdit}
        onOpen={onOpen}
        onCustomization={onCustomization}
        onSelectToolbar={onSelectToolbar}
        onRouteChange={onRouteChange}
        onHighlight={this.onHighlight}
        onWebsitename={onWebsitename}
        onWebsiteBio={onWebsiteBio}
        highlight={this.state.highlight}
        handleOffClick={this.handleOffClick}
        setWrapperRef={this.setWrapperRef}
        onClickInside={this.onClickInside}
        onClickOutside={this.onClickOutside}
        controller={this.state.controller}
        onController={this.onController}
        profile_name = {this.state.profile_name}
        profile_bio = {this.state.profile_bio}
        about = {this.state.about}
        icons = {this.state.icons}
        background = {this.state.background}
        onOuterDiv = {this.onOuterDiv}
        onInnerDiv = {this.onInnerDiv}
        outerdiv = {this.state.outerdiv}
        font_name = {this.state.font_name}
        onAboutSwitch={this.onAboutSwitch}
        themeAbout={this.state.themeAbout}
         />
      );
    case 'addData':
      return (
           <AddData
          onRouteChange={onRouteChange}
          onHighlight={this.onHighlight}
          onWebsitename={onWebsitename}
          onWebsiteBio={onWebsiteBio}
          highlight={this.state.highlight}
          onUser={onUser}
          onClickInside={this.onClickInside}
          onClickOutside={this.onClickOutside}
          onOpen={onOpen}
           />
        );
    default:
    	return (
         <Template
         onRouteChange={onRouteChange}
         template={onSelectTemplate}
         websitename={onWebsitename}
         websiteurl={onWebsiteurl}
         onCustomization={onCustomization}
         />
      );
  }
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);